<div class="sh-compact-navigation">
    <div class="application-information" *ngIf="showApplicationInformation">
        <p>{{ applicationName }}</p>
        <p>{{ applicationEnvironment}}</p>
        <p>{{ applicationVersion }}</p>
    </div>
    <sh-compact-navigation-main-action *ngIf="mainActionItem" [item]="mainActionItem"></sh-compact-navigation-main-action>
    <ul
        class="sh-navigation__list"
        *ngIf="(primaryNavItems$ | async) as primaryNavItems"
        (mouseleave)="noneSelected(primaryNavItems, true)"
        (shClickOutside)="noneSelected(primaryNavItems, true)"
        [shClickOutsideFocusEvent]="'mouseenter'"
    >
        <li class="sh-compact-navigation__list__item" *ngFor="let item of primaryNavItems;let i = index;trackBy:trackByHash">
            <sh-compact-navigation-item [item]="item" (selected)="selectionChanged($event, i, primaryNavItems, true)"></sh-compact-navigation-item>
        </li>
    </ul>
    <ul
        class="sh-navigation__list -sh-to-bottom"
        *ngIf="(secondaryNavItems$ | async) as secondaryNavItems"
        (mouseleave)="noneSelected(primaryNavItems, true)"
        (shClickOutside)="noneSelected(secondaryNavItems, false)"
        [shClickOutsideFocusEvent]="'mouseenter'"
    >
        <li class="sh-compact-navigation__list__item" *ngFor="let item of secondaryNavItems;let i = index;trackBy:trackByHash">
            <sh-compact-navigation-item
                [item]="item"
                [openDropmenuAbove]="true"
                (selected)="selectionChanged($event, i, secondaryNavItems, false)"
            ></sh-compact-navigation-item>
        </li>
    </ul>
</div>
